import clsx from "clsx"
import ChevronDownIcon from "~/icons/ChevronDownIcon"
import "./ScrollButton.css"

interface ScrollButtonProps extends React.HTMLAttributes<HTMLDivElement> {}

const ScrollButton = (props: ScrollButtonProps) => {
    const {onClick, className, ...otherProps} = props
    return (
        <div className={clsx("scroller-r94f", className)} {...otherProps}>
            <div className="mouse-r94f">
                <div className="scroll-r94f"></div>
            </div>
            <ChevronDownIcon className="icon-r94f" />
        </div>
    )
}

export default ScrollButton
